namespace SPA {
	export namespace Realtor {
		export class DocumentBoxView extends Backbone.View<SPA.Realtor.DocumentModel> {

			public constructor(options?: Backbone.ViewOptions)
			{
				if (options === undefined) {
					options = {};
				}
				options.tagName = 'form';
				options.className = 'doc-card master-card';
				options.attributes = {enctype: 'multipart/formdata', method: 'post'};

				options.events  = {
					"submit": "onFormSubmit",
					"click h3": "onHeadlineEdit",
					"click .action-preview": "onPreviewClick",
					"click .action-send": "onForwardAction",
					"click .action-download": "onDocumentDownload",
					"click .action-upload": "onDragDrop",
					"click .action-order": "onOrderClick",
					"click .action-delete": "onDeleteAction",
				};

				super(options);
			}

			public render() {
				console.log(this.model);

				const Box: JQuery = this.$el.empty()
					.append(this.BuildHeadline())
					.append(this.BuildActionBar())
					.append(this.BuildPreviewArea())
					.append(this.BuildFooterArea())
					.append(`<input type="hidden" name="did" value="${this.model.get('id')}">`)
					.append('<input type="file" name="files[]" class="hidden" multiple>');

				return this;
			}

			private BuildHeadline(): JQuery
			{
				// Todo move parsing to model side
				const title: string = this.model.get('default_id') === 0 ? this.model.get('title') : this.model.get('default_title');
				const headline = $(`<h3><span>${title}</span>'`);

				return headline;
			}

			private BuildActionBar(): JQuery {
				const actionbar = $('<div class="doc-actionplane">');

				if (this.model.get('shop_item')) {
					const btnOrder = $(`
						<button type="button" class="btn btn-primary action-order" title="Bestellen">
							<i class="fas fa-paper-plane"></i>
						</button>`);
					actionbar.append(btnOrder);
				}
				const item: string = this.model.get('shop_item');
				// Sonderfall (11 Grundbuch, 12 Baulasten) - Vollmacht herunterladen
				if (item === "DEED" || item === "ER") {
					const btnAuthority = ui.$$.button()
						.addClass('btn btn-primary action-order').attr({
							type: 'button',
							title: 'Vollmacht herunterladen'
						})
						.append($('<i class="fas fa-file"></i>'));
					btnAuthority.on('click', () => {
						let filepath: string = '';
						const link = document.createElement("a");

						if (item === "DEED") {
							filepath = app.getRemotePath() + 'Vollmacht_Grundbuch.pdf';
							link.download = 'Vollmacht Grundbuch.pdf';
						} else if (item === "ER") {
							filepath = app.getRemotePath() + 'Vollmacht_Baulastenverzeichnis.pdf';
							link.download = 'Vollmacht Baulastenverzeichnis.pdf';
						}
						link.href = filepath;

						link.setAttribute('target', '_blank');
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					});
					actionbar.append(btnAuthority);
				}

				if (this.model.get('shop_item') || this.model.get('default_id') === 11 || this.model.get('default_id') === 12) {
					actionbar.append($('<div class="vspacer">'));
				}

				if (this.model.get('id'))
				{
					actionbar.append(`
						<button type="button" title="Öffnen" class="btn btn-primary action-preview"><i class="fas fa-tv"></i></button>
						<button type="button" title="Weiterleiten" class="btn btn-primary action-send"><i class="fas fa-envelope"></i></button>
						<button type="button" title="Download" class="btn btn-primary action-download"><i class="fas fa-download"></i></button>
						<div class="vspacer"></div>
					`);
				}

				// Upload Button
				actionbar.append('<button type="button" title="Upload" class="btn btn-default action-upload"><i class="fas fa-upload"></i></button>')

				// Delete button
				if (this.model.get('id'))
				{
					actionbar.append('<button type="button" class="btn btn-danger action-delete" title="Dokument löschen"><i class="fas fa-trash"></i></button>');
				}

				return actionbar;
			}

			private BuildPreviewArea(): JQuery
			{
				const previewArea = ui.$$.div().addClass('doc-preview');

				if (this.model.get('id') && this.model.get('filename').indexOf('.pdf') === -1) {
					const btnShowForPrint = $('<button type="button" title="Print-Exposé"><i class="fas fa-file-alt"></i></button>');
					const btnShowOnline = $('<button type="button" title="Online-Exposé"><i class="fas fa-globe"></i></button>');

					$(btnShowForPrint).on('click', (e: Event) => {
						$(e.currentTarget as EventTarget).toggleClass('enabled');
					});
					$(btnShowOnline).on('click', (e: Event) => {
						$(e.currentTarget as EventTarget).toggleClass('enabled');
					});

					previewArea.append(btnShowForPrint).append(btnShowOnline);
				}

				let previewType = ui.$$.img().addClass('doc-placeholder');
				let previewSrc = 'assets/images/placeholder-image.png';
				let previewAttr = 'src';

				if (this.model.get('id')) {
					let params = '';
					let filename = '';
					if (this.model.get('filename').indexOf('{') === 0) {
						filename = JSON.parse(this.model.get('filename')).remote;
					} else {
						filename = this.model.get('filename');
					}
					if (this.model.get('id') && filename.indexOf('.pdf') !== -1) {
						// previewType = ui.$$.iframe();
						previewType = $('<embed>');
						previewAttr = 'src';
						params = '#view=FitH&scrollbar=1&toolbar=0&statusbar=0&messages=0&navpanes=0';
					}

					previewSrc = filename.indexOf('http') === 0
						? filename
						: app.getRemotePath() + this.model.get('ObjectNumber') + '/' + this.model.get('default_id') + '/' + this.model.get('filename');
					previewSrc += params;
				}

				previewType
					.attr(previewAttr, previewSrc)
					.appendTo(previewArea);

				// Add status marker to default documents only
				if (this.model.get('default_id')) {
					const status = ui.$$.div().addClass('status');
					if (this.model.get('id')) {
						status.addClass('status-ok');
						status.append('<i class="fas fa-check">');
					} else {
						status.addClass('status-fail');
						status.append('<i class="fas fa-times">');
					}
					status.appendTo(previewArea);
				}

				// Add custom upload event
				$(this.FileInput).on('change', (e: Event) => {
					this.onDragDrop(previewArea);
				});

				// Add drag & drop events
				previewArea.on('dragover drop', (e) => {
					e.preventDefault();

					if (e.type === 'dragover') {
						// We have to capture dragover and drop for d&d to work
						return;
					}
					this.FileInput.files = e.originalEvent.dataTransfer.files;
					this.onDragDrop(previewArea);
				})
					.on('click', (e) => {
						if (e.target.tagName.toLowerCase() === 'img') {
							let tagname = 'img';

							if (!this.model.get('filename')) {
								return;
							}

							if (this.model.get('filename').indexOf('.pdf') !== -1) {
								tagname = 'iframe';
							}

							const element = document.createElement(tagname);
							// Using the default_id as storage folder
							// @todo take document_id into account
							element.src = this.model.get('filename') + params;

							new ui.dialog.Modal({
								size: 'quick7',
								noCloseBtn: false,
								body: [
									preview
								]
							});
						}
					});

				return previewArea;
			}

			private BuildFooterArea(): JQuery {
				$(this.FileInput).hide();

				const status = ui.$$.div().addClass('doc-status-list clear')
					.append(ui.$$.span().addClass('doc-status-desc').text('Status:'))
					.append(ui.$$.span().addClass('doc-status-date').text(
						this.model.get('id') ? 'hinterlegt (' + this.model.get('created_at') + ')' : 'nicht hinterlegt')
					)
					.append(this.FileInput);

				return status;
			}

			private onFormSubmit(e)
			{
				e.preventDefault();

				const ajaxData = new FormData(this.el);

				if (!ajaxFile) {
					return;
				}

				for (const file of ajaxFile) {
					ajaxData.append('files[]', file);
				}

				ajaxData.append('contractor_id', this.m_Data.Contractor.ID);
				ajaxData.append('object_number', this.m_Data.ObjectNumber);
				ajaxData.append('action', 'upload');
				ajaxData.append('did', file.id);
				$.ajax({
					url: '/Backend/documents.php',
					type: 'multipart/formdata',
					method: 'POST',
					data: ajaxData,
					dataType: 'json',
					cache: false,
					contentType: false,
					processData: false,
					complete: () => {
					},
					success: (data) => {
						let imgType: any;
						let imgSrc: string;
						let params: string;

						if (data.filename.indexOf('.pdf') !== -1) {
							imgType = ui.$$.iframe();
							params = '#view=FitH&scrollbar=1&toolbar=0&statusbar=0&messages=0&navpanes=0';
						} else {
							imgType = ui.$$.img();
							params = '';
						}
						imgType.attr('src', data.filename + params);

						const ph = cardForm.Root().find('.doc-placeholder');
						ph.replaceWith(imgType);
					}
				});
			}

			private onPreviewClick()
			{
				let params: string;
				let attr = 'src';
				let tagname = 'img';

				if (this.model.get('filename').indexOf('.pdf') !== -1) {
					tagname = 'iframe';
					attr = 'data';
					params = '#view=FitH&scrollbar=1&toolbar=0&statusbar=0&messages=0&navpanes=0';
				} else {
					params = '';
				}
				const element = document.createElement(tagname);
				// Using the default_id as storage folder
				// @todo take document_id into account
				const previewSrc = this.model.get('filename').indexOf('http') === 0
					? this.model.get('filename')
					: app.getRemotePath() + this.model.get('ObjectNumber') + '/' + this.model.get('default_id') + '/' + this.model.get('filename');
				element[attr] = previewSrc + params;

				new ui.dialog.Modal({
					size: 'quick7',
					noCloseBtn: false,
					body: [
						$(element)
					]
				});
			}

			private onDragDrop(e: JQuery.TriggeredEvent) {
				// Show file name or upload count as preview prior to upload
				const previewArea = $(e.currentTarget as EventTarget);

				previewArea.find('.name-preview').remove();
				previewArea.find('.doc-placeholder').hide();
				if (this.FileInput.files.length === 1 || this.MultiUpload === false) {
					previewArea.prepend('<div class="name-preview">' + this.FileInput.files[0].name + '</div>');
				} else {
					previewArea.prepend('<div class="name-preview">' + this.FileInput.files.length + ' Dateien</div>');
				}

				$(this.BoxForm).trigger('submit');
			}

			private onFormSubmit(e: Event) {
				e.preventDefault();

				const formData = new FormData();
				for (const file of this.FileInput.files) {
					formData.append('files[]', file);
					if (this.MultiUpload === false) {
						break;
					}
				}

				formData.append('action', 'upload');
				formData.append('id', this.model.get('id').toString());
				formData.append('default_id', this.model.get('default_id').toString());
				formData.append('group_id', this.model.get('group_id').toString());
				formData.append('contractor_id', app.getAuthenticationManager().getCompany().ID);
				formData.append('object_number', this.model.get('ObjectNumber'));

				$.ajax({
					url: (Wollmilch.useHTTPS ? "https" : "http") + "://" + Wollmilch.URL + 'documents.php?XDEBUG_SESSION_START=1',
					method: 'POST',
					data: formData,
					dataType: 'json',
					cache: false,
					contentType: false,
					processData: false,

					success: (response) => {
						for (const file of response.data) {
							if (this.model.get('default_id')) {
								// Replace the current box with a new one
								// @todo Currently only replacing one file at a time for a default box
								this.Document = file;
								this.Build();
								// const newBox: DocumentBox = new DocumentBox(this.model.get('ObjectNumber'), file);
								// $(this.BoxForm).replaceWith(newBox.Build());
							} else {
								// Add a new box for each uploaded item ...
								const newBox: DocumentBox = new DocumentBox(this.model.get('ObjectNumber'), this.model.get('Object'), file);
								// ... after the wildcard option
								$(this.BoxForm).after(newBox.Build());
							}
						}

						// Reset the multi upload form
						if (this.MultiUpload) {
							$(this.BoxForm).find('.name-preview').fadeOut();
							$(this.BoxForm).find('.doc-placeholder').fadeIn();
						}
					}
				});

				return false;
			}

			private onOrderClick(e) {
				new SPA.Shop.Page(this.model.get('shop_item'), this.model.get('Object'));
			}

			private onDeleteAction() {
				// Request confirm for deletion
				const proceed = confirm('Möchten Sie dieses Dokument wirklich unwiderruflich löschen?');
				if (proceed === false) {
					return;
				}

				const requestdata = {
					contractor_id: app.getAuthenticationManager().getCompany().ID,
					object_number: this.model.get('ObjectNumber'),
					action: 'delete',
					id: this.model.get('id')
				};

				new Wollmilch.AJAX({
					url: 'documents.php?XDEBUG_SESSION_START=1',
					data: requestdata,
					method: 'POST',
					on: {
						success: (text: string) => {
							const response: Wollmilch.ResponseObject = JSON.parse(text);
							if (!response.success) {
								alert('Fehler beim Löschen der Anlage');
								return;
							}

							if (this.model.get('default_id') === 0) {
								// Remove non-default attachments
								$(this.BoxForm).fadeOut(() => $(this.BoxForm).remove());
							} else {
								// Rebuild aka empty default attachment container
								// Todo where place what and when?
								// this.model.get('id') = 0;
								$(this.BoxForm).replaceWith(this.Build());
							}
						}
					}
				}, AJAXCallbase_e.ROOT).send();
			}

			private onHeadlineEdit(e: JQuery.Event) {
				{
					if (!this.model.get('default_id'))
					{
						return;
					}

					const headline = $(e.currentTarget);

					if (headline.data('editing') === true) {
						return;
					}
					headline.data('editing', true);

					// Hide current title
					headline.find('span').hide();

					// Add an input element
					const titleInput = ui.$$.input()
						.addClass('form-control')
						.val(this.model.get('title') || '');

					// Create and show a save button
					const titleSaveBtn = ui.$$.button().addClass('btn btn-primary').html('<i class="fas fa-save" title="Speichern"></i>')
						.on('click', this.onSaveClick);

					headline
						.append(titleInput)
						.append(titleSaveBtn);
				}
			}

			private onSaveClick(e) {
				e.preventDefault();

				// @Todo common working save function for files, replacements and so on
				const requestdata = {
					contractor_id: app.getAuthenticationManager().getCompany().ID,
					object_number: this.model.get('ObjectNumber'),
					id: this.model.get('id'),
					title: titleInput.val(),
					action: 'update',
				};

				new Wollmilch.AJAX({
					url: 'documents.php?XDEBUG_SESSION_START=1',
					method: 'POST',
					data: requestdata,
					on:
						{
							success: (text: string) => {
								const response: Wollmilch.ResponseObject = JSON.parse(text);
								if (!response.success) {
									alert('Fehler beim Aktualisieren der Anlage');
									return;
								}

								this.Document = response.data;
								this.Build();
							}
						}
				}, AJAXCallbase_e.ROOT).send();
			}

			private onDocumentDownload() {
				const element = document.createElement('a');

				// @todo dynamic storage cdn/cloud
				const filepath = this.model.get('filename');

				element.setAttribute('href', filepath);
				/* Chapter2 - stores document with description as document.name */
				element.setAttribute('target', '_blank');
				element.setAttribute('download', '');
				$(element).on('click', (e) => e.preventDefault());
				document.body.appendChild(element);
				element.click();
				document.body.removeChild(element);
			}

			private onForwardAction() {
				alert("Per E-Mail weiterleiten");
			}
		}
	}
}
